var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SylApi, SylConfigurator, } from '@syllepsis/adapter';
var updateConfig = function (editor, newConfig) {
    editor.configurator.update(__assign(__assign({}, newConfig), { module: newConfig.module }));
};
var init = function (mount, props) {
    var plugins = props.plugins, module = props.module, content = props.content, spellCheck = props.spellCheck, placeholder = props.placeholder, locale = props.locale, onError = props.onError, basicControls = __rest(props, ["plugins", "module", "content", "spellCheck", "placeholder", "locale", "onError"]);
    var configurator = new SylConfigurator(mount, plugins, __assign({ placeholder: placeholder, spellCheck: spellCheck, locale: locale, onError: onError }, basicControls));
    var editor = new SylApi(configurator, {
        module: module,
        content: content,
    });
    if (props.getEditor)
        props.getEditor(editor);
    return editor;
};
var SylEditorService = {
    updateConfig: updateConfig,
    init: init,
};
export { SylEditorService };
//# sourceMappingURL=Editor.js.map